<template>
    <div class="step-preloader">
        <img class="step-preloader__img" src="../icons/loaders_icon.gif">
    </div>
</template>

<script>
    export default {
        name: 'StepPreloader'
    }
</script>

<style lang="less">
    @import (less) '../styles/_media.less';

    .step-preloader {
        &__img {
            width: 100%;

            @media @tablet {
                width: auto;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/StepPreloader.vue